export default __webpack_public_path__ + "static/media/mission.6e40538b.jpg";